<template>
  <div class="flex flex-col items-center text-center">
    <div class="Profile-pic">
      <img v-if="userinfo" :src="userinfo.img_url" class="pic-userstyle" />
      <img
        v-else
        class="h-full pic-style"
        src="@/assets/images/logo/ProfileFA.svg"
      />
      <!-- <img
        v-else
        class="object-cover h-full w-full pic-style"
        
        src="@/assets/images/elements/apple-touch-icon.png"
      /> -->
    </div>
    <div class="AdminName">
      {{ userinfo ? userinfo.first_name : "admin" }}
      {{ userinfo ? userinfo.last_name : "1" }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      userinfo: "general/userinfo"
    })
  }
};
</script>

<style lang="scss" scoped>
.Profile {
  height: 150px;
  width: 150px;
}
.Profile-pic {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  border-style: none;
  box-shadow: inset rgba(0, 0, 0, 0.19) 0px 5px 5px;
  overflow: hidden;
  background-color: white;
  object-fit: cover;
}
.pic-style {
  display: inline;
  margin: 0 auto;
}

.pic-userstyle {
  height: 100%;
  width: 100%;
  display: inline;
  margin: 0 auto;
  object-fit: cover;
}
.AdminName {
  font-size: 1.5rem;
}
</style>
